/** Inline brand glyphs for the share channels. The app ships no icon library. */

type IconProps = { className?: string }

export const WhatsAppIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91 0 1.75.46 3.45 1.32 4.95L2 22l5.25-1.38a9.9 9.9 0 0 0 4.79 1.22h.01c5.46 0 9.91-4.45 9.91-9.91 0-2.65-1.03-5.14-2.9-7.01A9.82 9.82 0 0 0 12.04 2Zm0 1.67c2.2 0 4.27.86 5.83 2.42a8.2 8.2 0 0 1 2.41 5.82c0 4.54-3.7 8.24-8.25 8.24a8.23 8.23 0 0 1-4.2-1.15l-.3-.18-3.12.82.83-3.04-.2-.31a8.2 8.2 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.25-8.24Zm-3.2 4.41c-.15 0-.39.06-.6.28-.2.22-.79.77-.79 1.88s.81 2.18.92 2.33c.11.15 1.58 2.42 3.86 3.39.54.23.96.37 1.29.48.54.17 1.03.15 1.42.09.43-.06 1.33-.54 1.52-1.07.19-.53.19-.98.13-1.07-.06-.09-.2-.15-.43-.26-.22-.11-1.33-.66-1.53-.73-.21-.08-.36-.11-.5.11-.15.22-.58.73-.71.88-.13.15-.26.17-.48.06-.22-.11-.94-.35-1.79-1.11-.66-.59-1.11-1.32-1.24-1.54-.13-.22-.01-.34.1-.45.1-.1.22-.26.33-.39.11-.13.15-.22.22-.37.07-.15.04-.28-.02-.39-.06-.11-.5-1.22-.69-1.67-.18-.44-.36-.38-.5-.39h-.43Z" />
  </svg>
)

export const TelegramIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M21.94 4.6 18.6 20.3c-.25 1.1-.9 1.38-1.83.86l-5.06-3.73-2.44 2.35c-.27.27-.5.5-1.02.5l.36-5.16 9.4-8.49c.4-.36-.09-.57-.63-.2L4.13 13.1l-5-1.56c-1.09-.34-1.1-1.09.23-1.61l19.55-7.54c.9-.34 1.7.21 1.03 2.21Z" />
  </svg>
)

export const LinkedInIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M4.98 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM3 9h4v12H3V9Zm6 0h3.84v1.64h.05c.54-.95 1.84-1.95 3.79-1.95 4.05 0 4.8 2.67 4.8 6.14V21h-4v-5.45c0-1.3-.03-2.97-1.81-2.97-1.81 0-2.09 1.41-2.09 2.87V21H9V9Z" />
  </svg>
)

export const FacebookIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="currentColor"
  >
    <path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5.02 3.66 9.18 8.44 9.94v-7.03H7.9v-2.91h2.54V9.85c0-2.52 1.49-3.92 3.78-3.92 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.78-1.63 1.57v1.89h2.78l-.44 2.91h-2.34V22c4.78-.76 8.43-4.92 8.43-9.94Z" />
  </svg>
)

export const MailIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m2 7 10 6 10-6" />
  </svg>
)

export const InstagramIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
  </svg>
)

export const LinkIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10 13a5 5 0 0 0 7.07 0l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
    <path d="M14 11a5 5 0 0 0-7.07 0l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
  </svg>
)

export const DownloadIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 3v12m0 0-4-4m4 4 4-4M4 21h16" />
  </svg>
)

/** Site-wide share / forward glyph (`boxicons_forward-big-filled`). */
export const ShareForwardIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 16 16"
    fill="currentColor"
  >
    <path d="M8.66536 5.9974H6.66536C3.7187 5.9974 1.33203 8.38406 1.33203 11.3307V13.3307L2.5987 11.7507C3.03631 11.2039 3.59123 10.7624 4.22244 10.4589C4.85364 10.1554 5.54499 9.99771 6.24536 9.9974H8.67203V13.3307L14.672 7.9974L8.66536 2.66406V5.9974Z" />
  </svg>
)

/** @deprecated Use ShareForwardIcon — kept for ShareModal import path. */
export const NativeShareIcon = ShareForwardIcon

export const CloseIcon = ({ className }: IconProps) => (
  <svg
    aria-hidden
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
  >
    <path d="M6 6 18 18 M18 6 6 18" />
  </svg>
)
